import React from "react";

import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useAccordionToggle } from "react-bootstrap/AccordionToggle";

function MailToggle({
  eventKey,
  subject,
  sender,
  recipient,
  recipientIsCustomer,
  date,
  time,
  read,
  toggleOpen,
  open,
}: any) {
  const toggleFn: any = useAccordionToggle(eventKey, () => {
    toggleOpen();
  });

  return (
    <a className="preview" onClick={() => toggleFn()}>
      <div className="float-right fs-125">
        <span
          className={`icon ${
            read || !recipientIsCustomer ? "icon-mail-open" : "icon-mail"
          }`}
        />
      </div>
      <div className="date">
        <strong>{date}</strong> | {time} Uhr
      </div>
      <div className="sender">
        <strong>Absender:</strong> {sender}
      </div>
      <div className="recipient">
        <strong>Empfänger:</strong> {recipient}
      </div>
      <div className="betreff fs-125 py-2">
        {open && <span className="icon-down-open fs-075 ml-1" />}
        {!open && <span className="icon-right-open fs-075 ml-1" />}
        Betreff: {subject}
      </div>
    </a>
  );
}

function MailBody(props: any) {
  let readText = "Als gelesen markieren";
  if (props.read) {
    readText = "Als ungelesen markieren";
  }

  return (
    <>
      <div className="message-body">
        {props.body}
        {props.attachments && props.attachments.length > 0 && (
          <div className="attachements">
            <h5>Dateien:</h5>

            {props.attachments.map((attachment: any, idx: number) => (
              <Row key={`attach-${idx}`} className="no-gutters">
                <Col>{attachment.name}</Col>
                <Col className="text-right">
                  <a href={attachment.downloadUrl}>
                    <span className="icon-download-1"></span> DOWNLOAD
                  </a>
                </Col>
              </Row>
            ))}
          </div>
        )}
      </div>
      <div className="pb-3">
        {props.recipientIsCustomer && (
          <Button
            variant="outline-secondary"
            onClick={() => props.toggleRead(props.msgId)}
          >
            {readText}
          </Button>
        )}
        &nbsp;
        <Button onClick={() => props.reply()} variant="outline-primary">
          Antworten
        </Button>
      </div>
    </>
  );
}

interface IMailboxMessageProps {
  body: string;
  date: string;
  isRead: boolean;
  msgId: string;
  recipient: string;
  recipientIsCustomer: boolean;
  reply: any;
  sender: string;
  subject: string;
  time: string;
  toggleRead: any;
  attachments: any;
}

export default class MailboxMessage extends React.Component<IMailboxMessageProps> {
  state: { open: boolean };

  constructor(props: any) {
    super(props);
    this.state = { open: false };
  }

  render() {
    return (
      <div
        className={`box-message br-lg${
          this.props.isRead || !this.props.recipientIsCustomer
            ? ""
            : " status--new"
        } ${this.props.recipientIsCustomer ? "incoming" : "outgoing"}`}
      >
        <div className="indicator">
          <span
            className={
              this.props.isRead || !this.props.recipientIsCustomer
                ? "icon-ok"
                : "icon-flag"
            }
          />
        </div>
        <Accordion>
          <MailToggle
            subject={this.props.subject}
            date={this.props.date}
            time={this.props.time}
            read={this.props.isRead}
            sender={this.props.sender}
            recipient={this.props.recipient}
            recipientIsCustomer={this.props.recipientIsCustomer}
            open={this.state.open}
            toggleOpen={() => this.setState({ open: !this.state.open })}
            eventKey="0"
          />
          <Accordion.Collapse eventKey="0">
            <MailBody
              body={this.props.body}
              msgId={this.props.msgId}
              toggleRead={this.props.toggleRead}
              read={this.props.isRead}
              reply={this.props.reply}
              attachments={this.props.attachments}
              recipientIsCustomer={this.props.recipientIsCustomer}
            />
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  }
}
